var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import ValidationService from "../../../../Services/Shared/Validation.service";
import useUniqueId from "../../../Hooks/useUniqueId";
import EmailBodyForm from "../../../Presentational/Message/EmailBodyForm";
export const messageTemplateToFormState = (messageTemplate) => {
    return {
        name: messageTemplate.name,
        body: messageTemplate.body,
        subject: messageTemplate.subject,
        // @ts-expect-error - TS2322 - Type 'number | null | undefined' is not assignable to type 'number'.
        id: messageTemplate.id,
    };
};
export const messageTemplateFormStateToRequest = (formState) => {
    let request = null;
    request = {
        id: formState.id || null,
        name: formState.name,
        subject: formState.subject,
        body: formState.body,
    };
    // @ts-expect-error - TS2322 - Type '{ id: number | null; name: string; subject: string | undefined; body: string; }' is not assignable to type 'MessageTemplate'.
    return request;
};
const MessageTemplateForm = (_a) => {
    var _b;
    var { personalizationMenus } = _a, formProps = __rest(_a, ["personalizationMenus"]);
    const makeId = useUniqueId()[1];
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: ValidationService.makeClassName(formProps.errors, "name", "form-group required"), children: [_jsx("label", { htmlFor: makeId("name"), children: "Name" }), _jsx("input", { id: makeId("name"), type: "text", name: "name", placeholder: "Enter a name for your template", className: ValidationService.makeClassName(formProps.errors, "name", "form-control"), ref: formProps.register({ required: "Name is required" }) }), _jsx("div", { className: "invalid-feedback", children: (_b = formProps.errors.name) === null || _b === void 0 ? void 0 : _b.message })] }), _jsx(EmailBodyForm, Object.assign({}, formProps, { personalizationMenus: personalizationMenus })), _jsx("input", { type: "hidden", name: "id", ref: formProps.register })] }));
};
export default MessageTemplateForm;
